export default __webpack_public_path__ + "static/project-slide-8-2016-765-eef706342e5d4f0437ba4b4d149ba3e3.jpg";